import React from 'react'

const IconChevron = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='7'
      height='12'
      viewBox='0 0 7 12'
      fill='none'
    >
      <path
        d='M1 1L6 6L1 11'
        stroke='#9CA3AF'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default IconChevron
